import api from '../../../App/socket';

export const changeBikeModel = (_id, key, value) => (
    api.send({
        api: 'db',
        model: 'Bike_model',
        action: 'Update',
        options: {
            where: { _id },
            update: {
                [key]: value,
            },
        },
    }).then(response => (
        {
            result: response.options[key],
            status: response.options,
        }
    )).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/requests/change_bike_model_request.js